/**
 * @filter         Sepia
 * @description    Gives the image a reddish-brown monochrome tint that imitates an old photograph.
 * @param amount   0 to 1 (0 for no effect, 1 for full sepia coloring)
 */
const fs = `\
uniform float amount;

#define PI 3.1415926538


vec2 curvature = vec2(5.0);
vec2 scanLineOpacity = vec2(0.25, 0.25);
float vignetteOpacity = 1.0;
float vignetteRoundness = 4.0;
float brightness = 1.5;

//角を湾曲させる
vec2 curveRemapUV(vec2 uv){
    uv = uv * 2.0 - 1.0;
    vec2 offset = abs(uv.yx) / vec2(curvature.x, curvature.y);
    uv = uv + uv * offset * offset;
    uv = uv * 0.5 + 0.5;
    return uv;
}

//ラインを入れる
 vec4 scanLineIntensity(float uv, float resolution, float opacity){
     float intensity = sin(uv * resolution * PI * 2.0);
     intensity = ((0.5 * intensity) + 0.5) * 0.25 + 0.1;
     return vec4(vec3(pow(intensity, opacity)), 1.0);
 }


//角を暗くする
vec4 vignetteIntensity(vec2 uv, vec2 resolution, float opacity, float roundness){
    float intensity = uv.x * uv.y * (1.0 - uv.x) * (1.0 - uv.y);
    return vec4(vec3(clamp(pow((resolution.x / roundness) * intensity, opacity), 0.0, 1.0)), 1.0);
}

vec4 retro_color(vec4 color) {

  float r = color.r;
  float g = color.g;
  float b = color.b;

//  color.r =min(1.0, (r * (1.0 - (0.607 * amount))) + (g * (0.769 * amount)) + (b * (0.189 * amount)));
  color.g = min(1.0, (r * 0.349 * amount) + (g * (1.0 - (0.314 * amount))) + (b * 0.168 * amount));
  color.b = min(1.0, (r * 0.272 * amount) + (g * 0.534 * amount) + (b * (1.0 - (0.869 * amount))));

  return color;
}

vec4 retorCTR_filterColor(vec4 color, vec2 texSize, vec2 texCoord) {
    vec2 uv = texCoord;
     

    vec2 remappedUV = curveRemapUV(vec2(uv.x, uv.y));

    //grayscale
    //float gray = color.r * 0.3 + color.g * 0.59 + color.b * 0.11;
    //color = vec4(gray, gray, gray, color.a);

    color = retro_color(color);

    //add fog
    const vec4 fogColor = vec4(1, 1, 1, 255);
    color = mix(color, fogColor, 0.25);

    //ビネット
    color *= vignetteIntensity(uv, texSize, vignetteOpacity, vignetteRoundness);

    //走査線
    color *= scanLineIntensity(uv.x, texSize.y, scanLineOpacity.x);
    color *= scanLineIntensity(uv.y, texSize.x, scanLineOpacity.y);

    color *= vec4(vec3(brightness), 1.0);

    if (remappedUV.x < 0.0 || remappedUV.y < 0.0 || remappedUV.x > 1.0 || remappedUV.y > 1.0){
        color = vec4(0.0, 0.0, 0.0, 1.0);
    }
    
  return color;
}
`;

const uniforms = {
    amount: { value: 1, min: 0, max: 1 }
};

export default {
    name: 'retorCTR',
    uniforms,
    fs,
    passes: [{ filter: true }]
};